<template>
  <div class="page">
    <navigation adaption />
    <div class="top">
      <span class="back" @click="backHome">返回首页</span>
    </div>
    <div class="banner" @click="toPassCardDetail">
      <div class="content">
        审核暂未通过：<br>
        为你开启免审通道，一次拿<span class="important">{{ info.loanAmount }}</span>元 >
        <div v-if="countdownVisible" class="tunnel-countdown">距离免审通道关闭
          <van-count-down :time="countDownSeconds" @finish="countDownEnd">
            <template #default="timeData">
              {{ timeFormat(timeData.hours) }}:{{ timeFormat(timeData.minutes) }}:{{ timeFormat(timeData.seconds) }}
            </template>
          </van-count-down>
        </div>
      </div>
      <img src="./image/img_result_clean_pass_banner_trailing.png">
    </div>
    <div class="card shadow info">
      <div class="pass-rate">
        <span class="text">平台审核通过率<span class="rate">100%</span></span>
        <img src="./image/icon_result_clean_pass_triangle.png">
      </div>
      <div class="top-title">提现金额 (元)</div>
      <div class="amount">{{ info.loanAmount | amount }}</div>
      <div class="pass-tip">最终放款结果以资方审核为准，通过率高达98% <br> 放款被拒2-7个工作日内自动退款</div>
      <div class="price-info">
        <div class="price">
          <div class="real">¥{{ info.discountPrice }}</div>
          <div class="original">原价：¥{{ info.originalPrice }}</div>
        </div>
      </div>
      <nd-button class="open-and-use" @click="openAction" data-sensors-click>开通并使用「免审额度」提现</nd-button>
      <div class="protocol">
        开通即同意<span @click="toProtocol">《会员用户协议》</span>
      </div>
    </div>
    <div class="card shadow privilege-card">
      <div class="header">
        <div class="title">生活权益</div>
        <div class="more" v-if="!alreadyHasPassCard" @click="toPassCardDetail">更多 ></div>
      </div>
      <div class="cards">
        <div class="card" v-for="(item, index) in info.lifeBenefitList" :key="index" @click="toPassCardDetail">
          <div class="title">{{ item.equityTitle }}</div>
          <div class="discount">{{ item.equityDesc }}</div>
          <div class="bottom">
            <div class="image">
              <img class="icon" :src="item.icon">
              <img class="background" src="./image/icon_passcard_benefit_bottom.png">
            </div>
          </div>
        </div>
      </div>
    </div>

    <pass-card-dialog
      v-model="buyPassCardVisible"
      :price="info.originalPrice"
      :amount="info.discountPrice"
      :expirePrice="info.discountPrice"
      :supplire="info.supplier"
      :expireDate="info.expireTime"
      :loanAmount="info.loanAmount"
      @on-buy="dialogBuyAction"
      @to-protocol="toProtocol"
    />

    <version-tips  v-model="showVersionTips" />

  </div>
</template>

<script>
import { CountDown } from 'vant'
import { mapActions } from 'vuex'
import { setKey, isAndroid, versionStringCompare, getKey } from '@/assets/utils'
import { hasNativeMethod, jsBridge } from '../../assets/jsBridge'
import { WHPay } from '@/assets/buyVip'
import CountDownTool from '@/assets/CountDownTool.js'

const PassCardBuyGuidePopKey = 'PassCardBuyGuidePopKey'

// /withdraw/result3
export default {
  name: 'withdraw-result',
  components: {
    CountDown,
    'pass-card-dialog': () => import('@/components/pass-card-dialog')
  },
  data () {
    return {
      privilegeCards: [1, 2, 3],
      countDownSeconds: 0,
      buyPassCardVisible: false,
      showVersionTips: false,
      alreadyHasPassCard: false,
      info: {
        loanAmount: 0,
        discountPrice: 0,
        originalPrice: 0,
        supplier: '',
        expireTime: 0,
        lifeBenefitList: [{
          icon: '',
          equityTitle: '',
          equityDesc: ''
        }]
      }
    }
  },
  async created () {
    await this.getDetailInfo()
    await this.checkIfHasPassCard()
    await this.setCountDownTime()
    this.$bus.$emit('ready')
    this.showBuyGuidePopup()
  },
  computed: {
    countdownVisible () {
      return this.countDownSeconds > 0
    }
  },
  methods: {
    ...mapActions('withdraw', [
      'passCardRefusedDetail'
    ]),
    ...mapActions('vip', ['orderCreateX', 'getMemberShipStatus']),
    ...mapActions('user', ['getFloatViewInfo']),
    async checkIfHasPassCard () {
      const { success, data } = await this.getMemberShipStatus({
        memberTypes: ['PASS']
      })
      if (success) {
        this.alreadyHasPassCard = data.haveMember === 'Y'
      }
    },
    showVersionTipsDiff () {
      return isAndroid() &&
        hasNativeMethod('getUserInfo') &&
        getKey('appVersion') &&
        versionStringCompare('1.8.1.1', getKey('appVersion')) > 0
    },
    dialogBuyAction () {
      if (this.showVersionTipsDiff()) {
        this.$message('升级最新版本享受免审额度')
      } else {
        this.buy()
      }
    },
    async openAction () {
      if (this.showVersionTipsDiff()) {
        this.showVersionTips = true
      } else {
        this.buy()
      }
    },
    async buy () {
      WHPay(false)
    },
    toPassCardDetail () {
      if (this.alreadyHasPassCard) { return }
      const origin = process.env.VUE_APP_PAYURL
      const gid = localStorage.getItem('gid')
      const token = getKey('userInfo', 'token') || ''
      const data = `gid=${gid}&token=${token}`
      window.location.href = `${origin}/vip/pass?${data}&refurl=${window.location.origin}`
    },
    toProtocol () {
      if (this.info.supplier === 'JI_WEI') {
        this.$router.push('/protocol/vip-jw')
      } else if (this.info.supplier === 'WH') {
        this.$router.push('/protocol/vip-wh')
      } else {
        this.$router.push('/protocol/vip')
      }
    },
    countDownEnd () {
      this.countDownSeconds = 0
      localStorage.setItem(CountDownTool.Keys.PassCardCountDownTimeStamp, 0)
    },
    timeFormat (num) {
      if (num < 10) {
        return `0${num}`
      }
      return num === 0 ? '00' : num
    },
    async getDetailInfo () {
      const res = await this.passCardRefusedDetail()
      if (res.success) {
        const maxListCount = Math.min(3, res.data.lifeBenefitList.length)
        res.data.lifeBenefitList = res.data.lifeBenefitList.slice(0, maxListCount)
        this.info = res.data
      }
    },
    showBuyGuidePopup () {
      if (this.isIntervalDay(PassCardBuyGuidePopKey, 1)) {
        setTimeout(() => {
          this.buyPassCardVisible = true
        }, 500)
        setKey(PassCardBuyGuidePopKey, Date.now())
      }
    },
    withDraw () {
      if (this.showVersionTipsDiff()) {
        this.showVersionTips = true
        return
      }
      this.$router.push({ path: '/withdraw/index',
                          query: { from: 'passcard' } })
    },
    async setCountDownTime () {
      const time = localStorage.getItem(CountDownTool.Keys.PassCardCountDownTimeStamp)
      if (time && time !== 0) {
        // 本地有倒计时数据
        const timeStamp = parseInt(time)
        const now = Date.now()
        if (now < timeStamp) {
          // 当前时间小于倒计时结束时间，继续倒计时
          this.countDownSeconds = timeStamp - now
        } else {
          // 当前时间大于等于倒计时结束时间，清空本地倒计时数据并重新获取倒计时
          localStorage.setItem(CountDownTool.Keys.PassCardCountDownTimeStamp, 0)
          await this.getFloatViewInfoX()
        }
      } else {
        // 本地没有倒计时数据，重新获取倒计时信息
        await this.getFloatViewInfoX()
      }
    },
    async getFloatViewInfoX () {
      const response = await this.getFloatViewInfo({
        showPlace: 'HOME'
      })
      const { success, data } = response
      if (success) {
        this.countDownSeconds = data.passCardFloatBean?.channelCountDownTime * 1000
        const timeStamp = Date.now() + this.countDownSeconds
        localStorage.setItem(CountDownTool.Keys.PassCardCountDownTimeStamp, timeStamp)
        if (hasNativeMethod(CountDownTool.Keys.AndroidNativeCountDownMethod)) {
          jsBridge(CountDownTool.Keys.AndroidNativeCountDownMethod, { time: timeStamp })
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.page {
  background: #F7F7F7;
  padding: 0 30px;
  .top {
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    padding:30px 0;
    margin: 22px 0;
    .back {
      float: right;
      text-decoration: underline;
      text-align: right;
    }
    .withdraw {
      float: right;
      text-align: right;
    }
  }
  .important {
    font-weight: bold;
  }
  .banner {
    padding: 21px 0 21px 20px;
    width: 100%;
    margin-bottom: 25px;
    background: linear-gradient(90deg, #FCD5AC 0%, #FEF6E4 100%);
    border-radius: 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .content {
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #763E12;
      line-height: 40px;
      .tunnel-countdown {
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FF4633;
        line-height: 33px;
        margin-top: 13px;
        display: flex;
        flex-direction: row;
        align-items: center;
        .van-count-down {
          margin: 0 5px;
          font-size: 24px;
          color: #FF4633;
        }
      }
    }
    img {
      width: 125px;
      height: 78px;
      margin-left: 77px;
    }
  }
  .card {
    background: #fff;
    width: 100%;
    margin-bottom: 20px;
    border-radius: 20px;
  }
  .shadow {
    box-shadow: 0px 10px 20px 0px rgba(211,211,211,0.5);
  }
  .info {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    .pass-rate {
      font-size: 28px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      line-height: 40px;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      padding-top: 50px;
      padding-left: 330px;
      .text {
        background: linear-gradient(90deg, #FFEB82 0%, #FFD450 100%);
        padding: 5px 26px;
        border-radius: 20px;
        color: #7F3800;
        .rate {
          color: #FF3333
        }
      }
      img {
        margin-left: 31px;
      }
    }
    .top-title {
      font-size: 30px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 42px;
      margin-top: 20px;
    }
    .amount {
      font-size: 72px;
      font-family: DIN-Medium, DIN;
      font-weight: 500;
      color: #333333;
      line-height: 87px;
    }
    .pass-tip {
      font-size: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #AAAAAA;
      line-height: 28px;
      margin-top: 12px;
      text-align: center;
    }
    .price-info {
      width: 630px;
      height: 171px;
      background-color: #FAFAFA;
      background: url(./image/img_result_clean_pass_price_bg.png) no-repeat center;
      background-size: cover;
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      align-items: center;
      padding-right: 30px;
      margin-top: 15px;
      .price {
        display: flex;
        flex-direction: column;
        align-items: center;
        .real {
          font-size: 44px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #763E12;
          line-height: 62px;
        }
        .original {
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #763E12;
          line-height: 33px;
          margin-top: 6px;
          text-decoration: line-through;
        }
      }
    }
    .open-and-use {
      width: 610px;
      height: 80px;
      line-height: 80px;
      margin-top: 39px;
      font-size: 36px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      animation: btnScale 1s linear infinite;
    }
    .protocol {
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 33px;
      margin-top: 30px;
      padding-bottom: 60px;
      span {
        color: #8EB2D8;
      }
    }
  }
  .privilege-card {
    padding: 30px;
    display: flex;
    flex-direction: column;
    .header {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      .title {
        font-size: 34px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 48px;
      }
      .more {
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 33px;
      }
    }
    .cards {
      margin-top: 21px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      .card {
        width: 30%;
        aspect-ratio: 1;
        background-color: #F7F1EB;
        padding: 20px 20px 0 20px;
        margin-bottom: 0;
        .title {
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 40px;
          margin-bottom: 4px;
        }
        .discount {
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 33px;
        }
        .bottom {
          display: flex;
          flex-direction: row;
          justify-content: flex-end;
          .image {
            display: flex;
            flex-direction: column;
            align-items: center;
            .background {
              width: 86px;
              height: 46px;
            }
            .icon {
              width: 56px;
              aspect-ratio: 1;
              margin-bottom: -10px;
              z-index: 2;
            }
          }
        }
      }
    }
  }
}
</style>